import GenericFilter from "./GenericFilter";
import ProductListing from "./ProductListing";
import React, { Component } from "react";
import UrlFilterHelper from "./UrlFilterHelper";
import AppliedFilters from "./AppliedFilters";
import Spinner from "./Spinner";
import { updateProductGroupItemList } from "./SchemaOrgGraph";

class ProductFilter extends Component {
  constructor(props) {
    super(props);
    this.url = i18n.baseUrl + "api/productcategoryfilter/search";

    this.state = {
      error: false,
      loading: true,
      products: [],
      filterGroups: [],
      totalMatching: 0,
    };
    this.bindThis();
    this.filterHelper = new UrlFilterHelper();
  }

  bindThis() {
    // Make 'this' work in event functions
    this.onFilterChanged = this.onFilterChanged.bind(this);
    this.handleFilterStorage = this.handleFilterStorage.bind(this);
    this.handleFilterStorageGetOrSet = this.handleFilterStorageGetOrSet.bind(this);
  }

  componentDidMount() {
    this.handleFilterStorageGetOrSet();
    this.getData(this.filterHelper.getFilters());
  }

  getData(filters) {
    this.setState({ loading: true });
    let apiResponseTimer = performance.now();

    fetch(this.url, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify({
        code: this.props.productAreaCode,
        selectedFilters: filters ?? [],
      }),
    })
      .then((data) => data.json())
      .then((data) => {
        try {
          let storedFilters = sessionStorage.getItem("storedFilters");
          if (storedFilters) {
              var arr = JSON.parse(storedFilters);

            arr.forEach((sf) => {
              let match = data.filters.filter((x) => x.id === sf.id)[0];
              if (match) {
                if (sf.type === 3) {
                  match.selectedMin = sf.selectedMin;
                  match.selectedMax = sf.selectedMax;
                } else {
                  var arr2 = sf.items;
                  arr2.forEach((item) => {
                    var matches = match.items.filter((x) => x.value === item.value);
                    if (matches) {
                      matches.forEach((match2) => {
                        match2.selected = true;
                      });
                    }
                  });
                }
              }
            });
          }
        } catch (error) {
          this.setState({ loading: false, error: true });

          console.log(error);
        }

        return data;
      })
      .then(
        (data) => {
          this.filterHelper.setFilters(data.filters || []);
          updateProductGroupItemList(data.items);

          this.setState({
            filterGroups: data.filters || [],
            products: data.items || [],
            totalMatching: data.totalMatching || 0,
            loading: false,
            error: false,
          });

              // Try send event to analytics
              try {
                  apiResponseTimer = Math.round(performance.now() - apiResponseTimer);
                  console.log("Productcategory api " + apiResponseTimer);

                  dataLayer.push({
                      'event': 'cejn.event',
                      'eventCategory': 'category-filter-performance-api',
                      'eventAction': window.location.pathname,
                      'eventLable': apiResponseTimer,
                  });

              } catch(e) {
                  console.log(e);
              };

            
        },
        (error) => {
          this.setState({
            error: true,
            loading: false,
          });
        }
      );
  }

  handleFilterStorage(filters) {
    sessionStorage.removeItem("storedFilters");
    if (Array.isArray(filters) && filters.length > 0) { 
          sessionStorage.setItem("storedFilters", JSON.stringify(filters));
    }
  }

  handleFilterStorageGetOrSet() {
      let storedFilters = JSON.parse(sessionStorage.getItem("storedFilters"));
      if (Array.isArray(storedFilters) && storedFilters.length > 0) {
          sessionStorage.setItem("storedFilters", JSON.stringify(storedFilters));
      } else {
          sessionStorage.removeItem("storedFilters");
      }
  }

  onFilterChanged() {
    let appliedFilterGroups = this.getAppliedFilterGroups(this.state.filterGroups);
    this.handleFilterStorage(appliedFilterGroups);
    this.getData(appliedFilterGroups);
  }

  getAppliedFilterGroups(filterGroups) {
    let appliedFilters = [];

    filterGroups.forEach((filterGroup) => {
      if (filterGroup.selectedMin && filterGroup.selectedMax) {
        let filterGroupCopy = {
          id: filterGroup.id,
          selectedMin: filterGroup.selectedMin + "",
          selectedMax: filterGroup.selectedMax + "",
          text: filterGroup.text,
          type: filterGroup.type,
        };

        appliedFilters.push(filterGroupCopy);
      }

      let selectedItems = filterGroup.items.filter((item) => item.selected);
      if (selectedItems.length) {
        // Create a copy so we don't mess with the filters applied
        let filterGroupCopy = {};
        Object.assign(filterGroupCopy, filterGroup);
        filterGroupCopy.items = selectedItems;
        appliedFilters.push(filterGroupCopy);
      }
    });
    return appliedFilters;
  }

  render() {
    if (this.state.loading) {
      return <Spinner />;
    }

    return (
      <>
        {this.state.error && (
          <div className="c-product-overview">
            <h2>{i18n.getString("generalError")}</h2>
          </div>
        )}

        <div className="c-product-overview">
          <div className="c-product-filter row">
            <GenericFilter onFilterChanged={this.onFilterChanged} filterGroups={this.state.filterGroups} />
          </div>
        </div>

        <AppliedFilters
          filterGroups={this.state.filterGroups}
          onCleared={this.onFilterChanged}
          onFilterRemoved={this.onFilterChanged}
        />

        <ProductListing
          loading={this.state.loading}
          items={this.state.products}
          expandText={i18n.getString("productFilter.expandTechnicalData")}
          heading={i18n.getString("productFilter.productListingHeader")}
          totalMatching={this.state.totalMatching}
        />
      </>
    );
  }
}

export default ProductFilter;
